import { createUseStyles } from "react-jss";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles({
  toggleMenu: {
    width: "24px",
    height: "24px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "32px",
    cursor: "pointer",
    display: "none",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "initial"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      right: "16px",
    }
  }
});

export default styles;
